export default __webpack_public_path__ + "static/media/buy_plan_banner_en_mobile.2fb6fb32.webp";